import { ISequenceStep, SequenceStepType } from '../interfaces/models/campaign';

export const SEQUENCE_STEP_LABELS: Record<SequenceStepType, string> = {
  connection_request: 'Connection request',
  message: 'Message',
  sn_message: 'InMail / Open Profile',
  profile_visit: 'Profile visit',
  post_like: 'Post like',
  post_comment: 'Post comment',
  email: 'Email',
};

export function formatSequenceSummary(steps: ISequenceStep[]): string {
  if (!steps.length) return 'No steps configured';
  return steps.map(s => SEQUENCE_STEP_LABELS[s.type]).join(' → ');
}

export type StepDelayField = 'delayDays' | 'delayHours';

type StepDelayFields = Pick<ISequenceStep, StepDelayField>;

function delayPart(value: number | undefined): number {
  return Math.max(0, parseInt(String(value ?? 0), 10) || 0);
}

/** The wait before a step, e.g. "2h", "1 day", "1 day 2h"; null when there is none. */
export function formatStepDelay(step: StepDelayFields): string | null {
  const days = delayPart(step.delayDays);
  const hours = delayPart(step.delayHours);
  const parts = [
    days ? (days === 1 ? '1 day' : `${days} days`) : '',
    hours ? `${hours}h` : '',
  ].filter(Boolean);
  return parts.length ? parts.join(' ') : null;
}

export function formatSequenceSummaryWithDays(steps: ISequenceStep[]): string {
  if (!steps.length) return 'No steps yet — add at least one';
  return steps
    .map(s => `${SEQUENCE_STEP_LABELS[s.type]} (${formatStepDelay(s) ? `after ${formatStepDelay(s)}` : 'no wait'})`)
    .join(' → ');
}
